import { render, staticRenderFns } from "./picshow.vue?vue&type=template&id=d32d13d4&scoped=true&"
import script from "./picshow.vue?vue&type=script&lang=js&"
export * from "./picshow.vue?vue&type=script&lang=js&"
import style0 from "./picshow.vue?vue&type=style&index=0&id=d32d13d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32d13d4",
  null
  
)

export default component.exports